export default {
  common: {
    Unsaved_changes: 'Unsaved changes',
    There_are_unsaved_changes_in_this_comment: 'There are unsaved changes in this comment.',
    Continue_editing: 'Continue editing',
    Drop_changes: 'Drop changes',
    Add_link: 'Add link',
    Enter_a_URL: 'Enter a URL',
    Link_text: 'Text',
    Enter_link_text: 'Enter text to display',
    Cancel: 'Cancel',
    Add: 'Add',
    Executed_by_agent: 'Executed by {agent}',
    Save: 'Save',
    Edit: 'Edit',
    Update: 'Update',
    Previous: 'Previous',
    Next: 'Next',
    Loading: 'Loading…',
    Total: 'Total',
    Details: 'Details',
  },
  dayoff: {
    select_title: 'Select your days off',
    selection_hint: 'Click a day · drag to select a range',
    today: 'Today',
    days_selected: 'day(s) selected',
    selected_days: 'Selected Days',
    legend_selected: 'Selected',
    legend_your: 'Your day off',
    legend_holiday: 'Public holiday',
    legend_mate: 'Teammate away',
    away_this_period: 'Away this period',
    nobody_away: 'No one is away in this period',
    description: 'Description',
    description_placeholder: 'e.g. Vacation, busy day…',
    submit: 'Save days off',
    saved: 'Days off saved: {range} — {count} day(s)',
    saved_empty: 'All days off removed',
    you: 'you',
    tip_holiday: 'Holiday',
    tip_away: 'Away',
    tip_out_count: '1 person out of office | {count} people out of office',
    tip_more: '+{count} more',
    days_count: '1 day | {count} days',
    tip_holiday_war: 'Not a day off during martial law',
    on_dayoff_today: 'On day off today',
    gcal_title: 'Google Calendar',
    gcal_connect: 'Connect Google Calendar',
    gcal_connected: 'Google Calendar synced',
    gcal_disconnect: 'Disconnect',
    history_title: 'Request history',
    history_period: 'Period',
    history_days: 'Days',
    history_note: 'Note',
    history_added: 'Added',
    history_empty: 'You haven\'t taken any days off yet',
    history_requests: '1 request | {count} requests',
    history_used_year: '1 day used this year | {count} days used this year',
    days_short: '{count}d',
    unsaved_title: 'Unsaved days off',
    unsaved_message: 'Your picked days and note are not saved yet.',
    unsaved_keep: 'Keep editing',
    unsaved_drop: 'Drop changes',
    clear: 'Clear selection',
  },
  board: {
    add_new_task: 'Add new task',
    add_stage: 'Add stage',
    add_column: 'Add column',
    enter_stage_name: 'Enter stage name',
    no_stages_title: 'No stages yet',
    no_stages_text: 'Add your first stage to start creating tasks.',
    need_stage_to_create_task: 'Add at least one stage to this project before creating a task.',
    Enter_task_description: 'Enter task description',
    Delete_stage: 'Delete stage',
    sure_delete_stage: 'Are you sure you want to delete this stage?',
    really_delete_stage: 'Do you really want to delete stage',
    stage_also_leted: 'All tasks in stage also will be deleted!',
    CANCEL: 'CANCEL',
    YES: 'YES',
    we_send_invite: 'We send an invite to email:',
    please_ask_user: 'Please ask user to accept link to join your project',
    okay: 'Okay',
  },
  comments: {
    bot_line1: 'Well done. You opened a task!',
    bot_line2: 'As you can see your time already counted in bottom right corner',
    bot_line3:
      'You can type a new message here or drag and drop file to add an attachment',
    max_pins_reached: 'Maximum 5 pinned comments allowed',
    pin_comment: 'Pin comment',
    pinned_comments: 'Pinned comments',
    add_reaction: 'Add reaction',
  },
  notifications: {
    title: 'Notifications',
    mark_all_read: 'Mark all read',
    read_all: 'Read all',
    all_caught_up: 'You\'re all caught up',
    all_caught_up_hint: 'Mentions, invites and requests will show up here',
    added_you_to_project: 'added you to project',
    open_project: 'Open project',
    rejected_invite_workspace: 'rejected invite to this workspace',
    requested_to_add: 'requested to add',
    for: 'for',
    Task: 'Task',
    task_created: 'created',
    task_deleted: 'deleted',
    task_transferred: 'transferred',
    task_restored: 'restored',
    Restore: 'Restore',
    image_deleted: 'Image deleted',
    NEW: 'NEW',
    Accept: 'Accept',
    Reject: 'Reject',
    Accepted: 'Accepted',
    Rejected: 'Rejected',
    Viewed: 'Viewed',
    Then_Deleted: 'Then Deleted',
    Then_Canceled: 'Then Canceled by',
    by: 'by',
    notify_assigned: 'assigned you to',
    mention_in_task: 'mention in',
    mentioned_you_in_task: 'mentioned you in task',
    to_a_task: 'to a task',
    new_assign: 'Assigned you to a task',
    offline_mode: 'Offline mode',
    no_new_version_found: 'No new version found',
    your_account_deleted: 'Your account has been deleted',
    dayoff_title: 'Day off',
    dayoff_notice: 'is off on {dates}',
    dayoff_takes: 'takes a day off',
    dayoff_is_off: '{name} is off',
    user_commented: '{name} commented',
    user_assigned_you: '{name} assigned you',
    open_task: 'Open task',
    open_calendar: 'Open calendar',
    invoice_autogen_failed: 'Failed to autogenerate the invoice for {month}, template',
    invoice_autogen_sent: 'The invoice for {month} was sent automatically, template',
    open_invoice_generator: 'Open invoice generator',
    dismiss: 'Dismiss',
  },
  uploads: {
    not_uploaded: '{count} not uploaded',
    queued: 'Queued',
    saving: 'Saving',
    done: 'Done',
    retry_attempt: 'Retry {attempt} of {max}',
    offline: 'Waiting for the network',
    failed: 'Not uploaded',
    retry: 'Retry',
    remove: 'Remove',
    errors: {
      too_large: 'Larger than {limit}, not uploaded',
      not_uploaded: "The file didn't reach the storage",
      storage_refused: 'The storage refused the file',
      unreachable_storage: "Couldn't reach the storage",
      server_error: "The server couldn't save the file",
    },
  },
  system: {
    syncing: 'Syncing',
    __resume_button: 'Resume',
    __ok_button: 'OK',
    __stop_button: 'Stop',
    __hide_button: 'Hide',
    __resume_last_task: 'Resume last task',
    __create_task_notify: 'Create task',
    __not_tracking_title: 'You\'re not tracking',
    __not_tracking_subtitle: 'for the last 10 minutes',
    __wait_install_app: 'Please, wait. Installing Tracklify...',
    __accept_button: 'Accept',
    __reject_button: 'Reject',
    __mute_tomorrow: 'Mute today',
    __muted_title: 'Reminders muted',
    __muted_subtitle: 'until tomorrow',
    __undo: 'Undo',
    __timer_running: 'Timer is running',
    __approve_tracked_time: 'Approve tracked time',
    __no_estimate: 'No estimate',
    __not_tracking_label: 'Not tracking',
    __until_tomorrow: 'Until tomorrow',
    __no_activity_detected: 'No activity detected',
    __open_app: 'Open app',
    __cancel: 'Cancel',
    __you_resume_tracking: 'You resumed tracking to:',
    /* Main notify */
    __tracker_was_closed: 'Tracker was closed with active track',
    __tracking_resume: 'Tracking resumed',
    __new_version_found: 'New version was found',
    __new_version_found_but_error:
      'New version was found, but auto-update is not supported on this system',
    __new_version_download_button: 'Download',
    __later_button: 'Later',
    __downloading_version: 'Downloading new version',
    __install_button: 'Install now',
    __downloading_version_percent: 'Downloading new version',
    __failed_download: 'Failed to download new version',
    __try_again: 'Try Again',
    __dismiss_button: 'Dismiss',
    __installing_new_version: 'Installing new version',
    __failed_install: 'Failed to install new version',
    __failed_open_new_version:
      'Failed to open new version. Please close and manually reopen application.',
    __close_app: 'Close app',
    __tracking_stopped: 'Tracking stopped: Idle timeout',
    __tricking_resume: 'Tracking resumed: system awaken',
    __tracking_stopped_shutdown: 'Tracking stopped: PC shutting down',
    __tricking_resume_unlocked: 'Tracking resumed: screen unlocked',
    __downloading_done: 'Downloading done',
  },
  appRunner: {
    open_now: 'Open Now',
    not_installed: 'Not installed',
    started: 'Started',
    starting: 'Starting',
    install_app_to_track: 'Get Desktop app',
    instalattion_is_simple:
      'Forget about "Share your screen" dialogs, get nice notifications and feel best user experience with Tracklify desktop app!',
    install_desktop: 'Install Desktop Tracklify app for uninterrupted tracking',
    authorize_app: 'Authorize your application',
    click_to_authorize: 'Click "Open now" to Open App as',
    install_step1: 'Download App by clicking on button below',
    install_step2: 'Run downloaded file',
    see_other_platforms: 'See downloads for other platforms',
    install_help: 'Installation help',
    done_button: 'Done',
    already_installed: 'Already installed? You can close this page.',
    download_app: 'Download App',
    download_app_deb: 'App for Ubuntu, Mint, other Debian-based',
    download_app_rpm: 'App for Redhat, Fedora, other RPM-based',
    download_app_pacman: 'App for Arch Linux, other Arch Linux-based',
    download_app_mac: 'Download macOS App (DMG)',
  },
  search: {
    search_or_navigate: 'Search or navigate',
    hint: 'Enter task text, member name,<br> tag or project name',
    nothing_found: 'Nothing found ¯\\_(ツ)_/¯',
    go_to: 'Go to',
    open: 'Open',
    in: 'in',
    in_tasks: 'Search in tasks:',
    invite: 'Invite',
    invite_to_project: 'to workspace and project',
    invite_user: 'Invite user',
    tasks_on: 'tasks on:',
    tasks_by: 'tasks by:',
    unassigned: 'Unassigned',
    noTag: 'No tags',
    clear_all: 'Clear all',
    clear: 'Clear',
    tagged: 'tagged',
    show_all_tags: 'Show all tags',
    on: 'on',
    by: 'by',
    sign_up_not_confirmed: 'Workspace sign up not confirmed',
  },
  combobox: {
    nothing_found: 'Nothing found',
    create_hint: 'Press Enter to add "{query}"',
    clear: 'Clear',
  },
  taskFilters: {
    filter: 'Filter',
    title: 'Filters',
    applyFilters: 'Apply filters',
    show_more: 'Show more',
    hide: 'Hide',
    createdTime: 'Created date',
    today: 'Today',
    yesterday: 'Yesterday',
    assignee: 'Assignee',
    executor: 'Executor',
    createdBy: 'Created by',
    tags: 'Tags',
    withTags: 'With tags',
    avgUserVelocityPerDay: 'Average user velocity per day',
    userAlreadyTrackedTimeByTag: 'Already tracked time by tag',
    estimation: 'Estimation',
    inTotal: 'In total:',
  },
  projectPriorities: {
    title: 'Project order',
    hint: 'Drag projects to set the order of their task groups in My Tasks. Urgent tasks always stay on top and low-priority tasks at the bottom.',
    empty: 'Not a member of any project yet',
    archived: 'Archived',
  },
  taskHistory: {
    empty: 'No tracked tasks here yet',
    empty_hint: 'Start a timer on a task, or change the period and filters.',
    search: 'Search',
    period: 'Period',
    projects: 'Projects',
    stages: 'Stages',
    search_placeholder: 'Search by name or number',
    projects_placeholder: 'All projects',
    stages_placeholder: 'All stages',
    all: 'All time',
    today: 'Today',
    yesterday: 'Yesterday',
    last_week: 'Last week',
    last_month: 'Last month',
    older: 'Older',
  },
  myTasks: {
    task_sorted_by_priority: 'Tasks by priority',
    mentions: 'Mentions',
    recents: 'Recents',
    liked: 'Favorites',
    total: 'total',
    total_unreads: 'unreads',
    total_updates: 'updates',
    no: 'no',
    markAllAsRead: 'Mark all as read',
    marking: 'Marking...',
    confirmMarkAllAsRead: 'Mark all mentions as read?',
    confirmMarkAllAsReadMessage: 'This will mark all mentioned tasks as read. This action cannot be undone.',
    openProject: 'Open project',
    open: 'Open',
  },
  menu: {
    Pause: 'Pause',
    PauseUntilWindowActivation: 'Pause until window activation',
    PauseFor5Minutes: 'Pause for 5 minutes',
    PauseFor10Minutes: 'Pause for 10 minutes',
    Resume: 'Resume',
    myTasks: 'My tasks',
    nav_menu: 'Menu',
    nav_tasks: 'Tasks',
    nav_alerts: 'Alerts',
    nav_me: 'Me',
    task_history: 'Task history',
    view_all_task_history: 'View all task history',
    __open_logs: 'Open logs',
    __check_updates: 'Check for updates',
    __enable_window_titles: 'Enable window titles',
    __devtools: 'DevTools',
    __quit: 'Quit',
    download_app: 'Get Desktop App',
    summary_report: 'Summary report',
    dayoff: 'Day Off',
    time_reports: 'Time reports & Invoices',
    time_report: 'Time report',
    invoice_generator: 'Generate invoice',
    salary: 'Salary',
    profit_share: 'Profit-share',
    projects: 'Projects',
    create_project: 'Create a new project',
    project_settings: 'Project settings',
    ai_assistant: 'AI Assistant',
    profile: 'Profile',
    dark_mode: 'Dark mode',
    my_screenshots: 'My screenshots',
    logout: 'Logout',
    get_help: 'Get help',
    about: 'About',
    ai_automation: 'AI & Automation',
    workspace: 'Workspace',
    switch_workspace: 'Switch workspace',
    workspace_settings: 'Workspace settings',
    create_new_workspace: 'New workspace',
    workspace_name: "Workspace name",
    personal_workspace: "Personal workspace",
    create_workspace: "Create",
    create_workspace_failed: "Couldn't create the workspace, please try again",
    invite_to_project: 'Invite a user to project',
    already_member_project: 'The user is already a member of the project',
    resend_invite_button: 'RESEND INVITE',
    no_users_found: 'No user found, enter email to invite.',
    invite_failed: "Couldn't invite {email}: check the address",
    settings: 'settings',
    Project_name: 'Project name',
    task_short_id: 'Used for task short IDs',
    Task_ID_example: 'Task ID example',
    already_taken: 'Already taken in workspace',
    Please_change: 'Please change it',
    Prefix: 'Prefix',
    Template: 'Template',
    Project_background: 'Project background',
    change: 'CHANGE',
    create: 'CREATE',
    Select_a_picture: 'Select a picture',
    Examples: 'Examples:',
    pick_a_color: 'Or pick a color',
    create_project_hint: 'Name it, pick a column template, and choose a background.',
    Search_pictures: 'Search pictures — abstract, gradient, lights…',
    Create_project: 'Create project',
    Resend_invite: 'Resend invite to project and workspace for',
    user_invite: 'Click on user to invite',
    get_app: 'Get app',
    add_task: 'Add',
    mentions_notify_1: 'You have',
    mentions_notify_2_single: 'mention task',
    mentions_notify_2_multy: 'mention tasks',
    task_create: 'Create a task',
    notifications: 'Notifications',
    no_new_notifications: 'No new notifications',
    new_notification: 'new',
    new_notifications: 'new',
  },
  reports: {
    executors: 'Executors',
    now_working: 'Now working',
    no_active_tasks: 'No active tasks',
    work_one_day: 'Work one day',
    today: 'TODAY',
    work_this_month: 'Work this month',
    member: 'Member',
    activity: 'Activity',
    total: 'Total',
    no_time_tracked: 'No time tracked',
    no_time_tracked_this_month: 'No time tracked this month',
    date_range: 'Date range',
    select_date_range: 'Select date range',
    show_filters: 'Show filters',
    hide_filters: 'Hide filters',
    filter_projects: 'Include projects',
    select_projects: 'Select projects',
    filter_labels: 'Only tasks with tags',
    filter_exclude_labels: 'Exclude tasks with tags',
    select_label: 'Select tag',
    filter_executors: 'Filter Executors',
    select_executors: 'Select executors',
    group_by: 'Group by',
    group_projects: 'Projects',
    by_weeks: 'By Weeks',
    by_month: 'By Month',
    dont_group: "Don't Group",
    no_tasks: 'No tasks for such request',
    total_time: 'Total time',
    total_time_by_day: 'Total time by day',
    burnup_chart: 'Burnup chart',
    all_spent: 'TOTAL<br/>SPENT',
    time_by_task: 'Time by task',
    invoice: 'Create invoice',
    roles: 'Roles',
    search: 'Search',
    select_all: 'Select all',
    unselect_all: 'Unselect all',
    now: 'now',
    Enter_project_name: 'Enter project name',
    screenshots: 'SCREENSHOTS',
    empty: 'Empty',
    screenshots_empty_title: 'No screenshots',
    screenshots_empty_hint: 'Nothing was captured for the selected dates and filters.',
    time_empty_title: 'No tracked time',
    time_empty_hint: 'Nothing was tracked for the selected dates and filters.',
    last_month: 'Last month',
    this_month: 'This month',
    this_year: 'This year',
    all_time: 'All time',
    Ok: 'Ok',
    YES: 'YES',
    CANCEL: 'CANCEL',
    Cancel: 'Cancel',
    Tasks: 'TASKS',
    Time: 'Time',
    Tasks_details: 'TASKS DETAILS',
    PriorityLow: 'Low',
    PriorityUsual: 'Usual',
    PriorityHigh: 'High',
    PriorityUrgent: 'Urgent',
    PrioritySuperUrgent: 'Super urgent',
    Unset: 'Unset',
    enter_variables_values: 'Enter variables values',
    are_you_sure_delete_template: 'Are you sure you want to delete a template?',
    are_you_sure_new_template: 'Are you sure want to save this template?',
    Template: 'Template',
    Select_template: 'Select template',
    New_template_name: 'New template name',
    DOWNLOAD_PDF: 'DOWNLOAD PDF',
    basic_example: 'Basic example',
    worker_salary: 'Worker salary',
    devforth_salary: 'Devforth Salary',
    executor: 'Executor',
    created: 'Created',
    contributors: 'Contributors',
    value: 'Value',
    progress: 'Progress',
    accuracy: 'Accuracy',
    spent_by: 'Spent by',
    by_executor: 'executor',
    total_spent_by: 'Total spent',
    by_contributors: 'by contributors',
    export: 'Export',
    configure_columns: 'Configure columns',
    more_actions: 'More actions',
    round_hours_to: 'Round hours to',
    export_to_csv: 'Export to CSV',
    export_to_gsheets: 'Export to Google Sheets',
  },
  placeholders: {
    e_g: 'e.g. New project',
    Type_anything: 'Type anything',
  },
  settings: {
    configure: 'Configure project',
    delete_project: 'Delete project',
    Can_not_be_empty: 'Can not be empty',
    New_prefix: 'New prefix',
    Save: 'Save',
    SaveAs: 'Save as',

    Cancel: 'Cancel',
    general: 'general',
    Labels: 'Tags',
    Members: 'Members',
    Tracker_Rules: 'Flow buttons',
    Notifications: 'Notifications',
    notification_settings_title: 'Project notifications',
    notify_member_dayoff: 'Notify me when a project member takes a day off',
    Stages: 'Stages',
    No_labels_yet: 'No tags yet',
    Admin: 'Admin',
    Not_a_member: 'Not a member',
    Member: 'Member',
    Role_on_project: 'Role on project',
    Actions: 'Actions',
    Permissions: 'Permissions',
    Other: 'Other',
    Invite_member: 'Invite member',
    exclude_the_user: 'Are you sure you want to exclude the user from project?',
    Exclude: 'Exclude',
    Configure_workspace: 'Configure workspace',
    Workspace_name: 'Workspace name',
    Logo: 'Logo',
    save: 'Save',
    Workspace_UI_language: 'Workspace UI language',
    Workspace_alias: 'Workspace alias',
    General: 'General',
    Priorities: 'Priorities',
    Edit_tag_name: 'Edit tag name:',
    Pick_a_color: 'Pick a color',
    DELETE_TAG: 'DELETE TAG',
    ARCHIVE_TAG: 'ARCHIVE TAG',
    UNARCHIVE_TAG: 'UNARCHIVE TAG',
    TASKS: 'TASKS',
    EDIT: 'EDIT',
    confirm_delete: 'Are you sure want to delete a project?',
    archive: 'Archive | archive | Archived',
    unarchive: 'Unarchive | unarchive',
    confirm_archive: 'Do you want to {action} this project?',
    cant_undone: 'This can’t be undone',
    confirm_user_deletion: 'Are you sure you want to delete the user?',
    CANCEL: 'CANCEL',
    YES: 'YES',
    Yes: 'Yes',
    delete: 'Delete',
    only_admin_can_delete_user: 'Only the workspace admin can delete a member',
    only_admin_can_change_language: 'Only the workspace admin can change the language',
    ADMIN: 'Admin',
    MEMBER: 'Team member',
    GUEST: 'Guest',
    FINANCE: 'Finance officer',
    admin_description: 'Able to all access',
    finance_description: 'Like member but also has access to all invoice templates',
    member_description: 'Able to access only projects where he is invited, but can see time reports for all members and all projects. Can see task names of alien projects.',
    guest_description: 'Able to access only projects where he is invited, sees time reports for all members of accessed projects.',
    doScreenshots: 'Do screenshots to proof work',
    single_admin_role_warning: 'You cannot modify permissions for the single admin',
    owner_role_warning: 'You cannot modify permissions for the workspace owner',
  },
  workspaceSettings: {
    general_subtitle: 'Workspace name, logo, language and brand color',
    members_subtitle: 'People in this workspace and their roles',
    priorities_subtitle: "Project order for each member's My Tasks",
    name_saved: 'Workspace name saved',
    logo_saved: 'Workspace logo saved',
    timezone_saved: 'Main timezone saved',
    brand_color: 'Brand color',
    main_timezone: 'Main timezone',
    search_timezone: 'Search timezone',
    language: 'Language',
    role: 'Role',
    admins: 'Admins',
    pending_invites: 'Pending invites',
    name_hint: 'Appears in the workspace switcher and on invitations.',
    language_hint: 'Default for everyone in the workspace.',
    brand_color_hint: 'Used in reports exported to Google Sheets.',
    timezone_hint: 'Task time reports and invoices count days in this timezone. Only the owner and admins can change it.',
  },
  projectSettings: {
    group_project: 'Project',
    group_people: 'People',
    group_automation: 'Automation',
    integrations: 'Integrations',
    general_subtitle: 'Project name and appearance',
    tags_subtitle: 'Labels used to categorize tasks on this board',
    stages_subtitle: 'Columns of the board — reorder to change the flow',
    members_subtitle: 'People with access to this project and their roles',
    flow_subtitle: 'Actions shown on the big flow buttons of the task page, per stage',
    integrations_subtitle: 'Connected services reporting into Tracklify',
    tasks_total: 'Tasks total',
    name_hint: 'Shown in the sidebar, board header and in every task reference.',
    background: 'Board background',
    background_hint: 'Image behind the board columns. Kept subtle so cards stay readable.',
    no_background: 'No background',
    photo_by: 'Photo by',
    screenshots_hint: 'Capture screenshots while the timer runs, attached to tracked time.',
    enabled: 'Enabled',
    disabled: 'Disabled',
    change: 'Change',
    archive_title: 'Archive this project',
    archive_hint: 'Hides it from the sidebar and board switcher. Tracked time stays in reports — you can restore it anytime.',
    archive_button: 'Archive project',
    unarchive_title: 'Restore this project',
    unarchive_hint: 'Brings it back to the sidebar and board switcher.',
    unarchive_button: 'Unarchive project',
    delete_title: 'Delete this project',
    delete_hint: 'Removes the project together with its tasks.',
    tag: 'Tag',
    used_on: 'Used on',
    tasks_count: '{count} tasks',
    edit: 'Edit',
    archived: 'Archived',
    archive: 'Archive',
    unarchive: 'Unarchive',
    add_tag: 'Add tag',
    new_tag: 'New tag',
    tag_name: 'Tag name',
    create: 'Create',
    stage: 'Stage',
    tasks: 'Tasks',
    order: 'Order',
    add_stage: 'Add stage',
    stage_name: 'Stage name',
    rename_stage: 'Rename stage',
    stage_name_hint: 'Visible as the column title on the board.',
    to_save: 'to save',
  },
  projectRules: {
    when_task_in_stage: 'When task in stage',
    secondary_button: 'Secondary button (left)',
    primary_button: 'Primary button',
    this_rule_willnot_work: 'This rule will not work',
    add_action: 'Add action',
    similar_item_was_used: 'similar item was used',
    preview: 'Preview',
    move: 'Move',
    move_to: 'Move to',
    assign: 'Assign',
    assign_if_not_assigned: 'Assign if not assigned',
    assign_mention: 'Assign mention',
    unassign: 'Unassign',
    auto_click_after: 'Auto click after',
    activate_button_if_user_mentioned_in_comment: 'Activate button, if user mentioned in comment',
    auto_click_after_tracked_1: 'Auto click after',
    auto_click_after_tracked_2: 'tracked',
    minutes: 'm',
    Me: 'Me',
    Task_creator: 'Task creator',
    no_buttons: 'No buttons shown',
  },
  task: {
    edited: 'edited',
    Actions: 'Actions',
    noDescription: 'No description yet',
    timeSpent: 'Time Spent',
    ago: 'ago',
    by: ', by',
    ADD_A_CHECKLIST: 'ADD A CHECKLIST',
    ADD_A_CHECKLIST_ITEM: 'ADD A CHECKLIST ITEM',
    Created_task_in: 'Created task in',
    Assigned: 'Assigned',
    Changed_task_description: 'Changed task description',
    Transferred_task_from: 'Transferred task from',
    Type_comment: 'Type comment',
    SET_EST: 'SET EST',
    SET_ESTIMATE: 'SET ESTIMATE',
    Clear: 'Clear',
    STORY_POINTS: 'STORY POINTS',
    Estimate: 'Estimate',
    Progress: 'Progress',
    Add_time: 'Add time',
    est: 'est',
    Code_block: 'Code block',
    List: 'List',
    Video: 'Video',
    USUAL: 'NORMAL',
    PRIO: 'Priority',
    Set_estimate_to: 'Set estimate to',
    Set_priority: 'Set priority',
    Delete_task: 'Delete task',
    Screenshots: 'View screenshots',
    Add_manual_time: 'Add manual time',
    Add_to_liked: 'Add to liked',
    CANCEL: 'CANCEL',
    YES: 'YES',
    Back_to_task: 'Back to task',
    What_were_you_doing: 'What were you doing?',
    manual_how_long: 'How long?',
    manual_set_exactly: 'or set it exactly',
    manual_description_placeholder: 'e.g. Client call about the Q4 roadmap',
    manual_request: 'Request {duration}',
    manual_pick_hint: 'Drag on the bar to pick when you worked',
    manual_tab_range: 'Time range',
    manual_tab_duration: 'Duration',
    manual_today: 'Today',
    manual_earlier: 'Earlier',
    manual_later: 'Later',
    manual_legend_tracked: 'Tracked',
    manual_legend_request: 'This request',
    manual_time_admin_required: 'Manual time is reviewed by a workspace admin, and this project has none. Add one to the project:',
    manual_time_request_refused: 'Manual time wasn\'t requested. Reload the page and try again.',
    manual_time_update_refused: 'Manual time wasn\'t updated: it was already handled or you no longer have access. Reload the page to see its current state.',
    Type_item: 'Type item',
    to_normal: 'to normal',
    ASSIGN: 'Assign',
    SEARCH_ASSIGNEE: 'Search for assignee',
    add: 'add',
    change: 'change',
    nowin: 'now in',
    Tags: 'Tags',
    Unassign: 'Unassign',
    just_now: 'just now',
    Removed_assignee: 'Removed assignee',
    Moved_to: 'Moved to',
    Added_tag: 'Added tag',
    Removed_tag: 'Removed tag',
    Added: 'Added',
    Reqested_to_add: 'Requested to add',
    Approved: 'Approved',
    Rejected: 'Rejected',
    Canceled: 'Canceled',
    Deleted: 'Deleted',
    by_trigger: 'by trigger',
    REMOVE: 'REMOVE',
    Are_you_sure: 'Are you sure?',
    Are_you_sure_you_want_to_delete_this_image: 'Are you sure you want to delete this image?',
    set_as_task_preview: 'Set as a preview',
    max_images_reached: 'You can upload up to {limit} images at a time',
    current_task_preview: 'Current preview',
    next_image: 'Next image',
    previous_image: 'Previous image',
    Are_you_sure_you_want_to_delete_this_comment: 'Are you sure you want to delete this comment?',
    Are_you_sure_you_want_to_delete_this_checklist_item: 'Are you sure you want to delete this checklist item?',
    Delete: 'Delete',
    Yes: 'Yes',
    No: 'No',
    manual_CANCEL: 'Cancel',
    manual_Remove: 'Remove',
    manual_YES: 'YES',
    delete_screenshot_title: 'Delete this screenshot?',
    delete_screenshot_subtitle: 'This can\'t be undone',
    Add_tags: 'Add tags',
    create_new_tag: 'Create new tag',
    search_or_create_tag: 'Search or create tag...',
    No_screenshots_here_enable: 'There are no screenshots here yet, please go ahead and track time and they will appear',
    No_screenshots_here_disable: 'Screenshots for this project disabled',
    No_screenshots_here_disable_admin_part1: 'Screenshots for this project disabled, open ',
    No_screenshots_here_disable_admin_part2: 'settings',
    No_screenshots_here_disable_admin_part3: ' to change it',
    SPENT: 'SPENT',
    oops: 'Oops!',
    cannot_find_page: 'We can\'t find a page you were looking for',
    start_from_home: 'Start from home',
    nf_title: 'Nothing to see here.',
    nf_subtitle: 'The page you requested doesn\'t exist. Check the URL or return to a familiar place.',
    go_to_homepage: 'Go to homepage',
    go_back: 'Go back',
    spent_time: 'Spent time',
    copy_to_clipboard: 'Copy to clipboard',
    copied_to_clipboard: 'Link is copied to the clipboard',
    copy_video_link: 'Copy link',
    volume: 'Volume',
    converting_video: 'Converting…',
    picture_in_picture: 'Picture in picture',
    expand_video: 'Expand',
    collapse_video: 'Collapse',
    we_are_still_processing_video: 'We\'re still processing the video',
    video_available_not_for_all_platforms: 'The video is not yet available for platforms which does not support modern video formats. We are performing additional conversion to MP4. Please wait.',
    move_to: 'Move to',
    unassign: 'Unassign',
    assign: 'Assign',
    unable_to_restore_image: 'Unable to restore the image',
    Record_screen: 'Record screen',
    screenshot_activity: 'Activity',
    my_last_screenshots: 'My last screenshots',
    view_all: 'View all',
    Executor: 'Executor',
    edit: 'edit',
    Stage: 'Stage',
    NoStage: 'No stage',
    Change_project: 'Change project',
    Please_select_project_to_move: 'Please select project to move',
    No_transfer_available: 'No transfer available',
    Created_by: 'Created by',
    PriorityLow: 'Low',
    PriorityUsual: 'Usual',
    PriorityHigh: 'High',
    PriorityUrgent: 'Urgent',
    PrioritySuperUrgent: 'Super urgent',
    Unset: 'Unset',
    transfer_unavailable: {
      not_creator: 'Only creator can transfer, and you are not the creator',
      single_project: 'There is only one project, so no project to transfer to',
      child_task: 'Cannot transfer a separate subtask',
    },
    are_you_sure_transfer_task: 'Are you sure you want to transfer task?',
    time_save_but_screenshots_unavailable: 'Time tracking screenshots and tracked time will be saved but unavailable in the transferred task.',
    screenshots_from_tracked_time: 'Screenshots from tracked time',
  },
  theme: {
    title: 'Theme',
    dark: 'Dark',
    light: 'Light',
    pink: 'Pink',
    violet: 'Violet',
    lime: 'Lime',
  },
  themeEditor: {
    new_theme: 'New theme',
    new_title: 'New theme',
    edit_title: 'Edit theme',
    unsaved_message: 'Your theme changes are not saved yet.',
    name: 'Name',
    name_placeholder: 'My theme',
    mode: 'Mode',
    colors: 'Colors',
    seed_base: 'Background',
    seed_ink: 'Text',
    seed_accent: 'Accent',
    fine_tune: 'Fine-tune',
    overrides_hint: 'Optional. Empty colors follow the ones above.',
    token_bg2: 'Panels',
    token_control: 'Buttons',
    token_card: 'Cards',
    token_chrome: 'Top bar',
    token_line: 'Borders',
    'token_text-muted': 'Secondary text',
    'token_accent-soft': 'Accent tint',
    token_red: 'Red',
    token_green: 'Green',
    token_blue: 'Blue',
    reset: 'Reset',
    share: 'Share with workspace',
    share_hint: 'Members of {workspace} can pick it too',
    shared: 'Shared with the workspace',
    shared_by: 'Shared by {name}',
    delete: 'Delete',
    delete_title: 'Delete theme?',
    cancel: 'Cancel',
    save: 'Save',
    preview: 'Preview',
    preview_project: 'Website redesign',
    preview_search: 'Search',
    preview_filters: 'Filters',
    preview_filter_mine: 'My tasks',
    preview_filter_tagged: 'With tags',
    preview_filter_tracked: 'Tracked today',
    preview_todo: 'To do',
    preview_doing: 'In progress',
    preview_done: 'Done',
    preview_card_onboarding: 'Onboarding screens',
    preview_card_ora: 'Limit ORA ORA ORA spam in comments',
    preview_card_invoices: 'Monthly invoices',
    preview_card_icons: 'New icon set',
    preview_card_clash_royale: 'Nerf Mega Knight',
    preview_tag_bug: 'Bug',
    preview_tag_design: 'Design',
    preview_tag_release: 'Release',
  },
  profile: {
    password_title: 'Make it hard to guess',
    password_hint: 'Requirements light up as you type.',
    rule_length: '{count} or more characters',
    rule_number: 'At least one number',
    rule_uppercase: 'An uppercase letter',
    rule_match: 'Both passwords match',
    rule_no_spaces: 'No spaces',
    rule_different: 'Different from the current password',
    save_password: 'Save password',
    username_required: "Name can't be empty",
    profile_saved: 'Profile saved',
    username_invalid: "Name can contain only letters, digits, spaces and . , - _ ' ’ & ( ) {'@'} +",
    profile_save_failed: "Couldn't save the profile, please try again",
    password_changed: 'Password changed',
    delete_title: 'Delete your account?',
    will_be_removed: 'Will be removed',
    removed_profile: 'Profile, photo and preferences',
    removed_access: 'Access to all workspaces and projects',
    removed_settings: 'Days off and personal settings',
    type_delete_prefix: 'Type',
    type_delete_suffix: 'to confirm',
    keep_account: 'Keep account',
    delete_forever: 'Delete forever',
    subtitle: 'Your personal account details and preferences',
    section_photo: 'Profile photo',
    section_personal: 'Personal information',
    section_appearance: 'Appearance',
    section_security: 'Security',
    section_danger: 'Danger zone',
    upload_new: 'Upload new',
    photo_hint: 'PNG or JPG, up to 5MB',
    name_hint: 'Visible to your teammates on tasks and comments',
    theme_hint: 'Applies to all your Tracklify workspaces and devices',
    change_password: 'Change password',
    delete_account_hint: "Permanently remove your account and all personal data. This can't be undone.",
    delete_account_button: 'Delete account',
    Cancel: 'Cancel',
    old_password_placeholder: 'Enter your current password',
    new_password_placeholder: 'At least {count} characters',
    repeat_password_placeholder: 'Repeat the new password',
    days_off_visibility_hint: "Choose who can see when you're away on your projects",
    days_off_everyone: 'Everyone',
    days_off_members_only: 'Members only',
    unsaved_changes: 'You have unsaved changes',
    Configure_user_profile: 'Configure user profile',
    General: 'General',
    Privacy: 'Privacy',
    days_off_visibility_title: 'Days off visibility',
    days_off_visible_to_everyone: 'Everyone on my projects, including workspace guests',
    days_off_hidden_from_guests: 'Only workspace members and admins on my projects',
    Name_Surname: 'Name & Surname',
    Avatar: 'Avatar',
    Email: 'Email',
    CHANGE_PASSWORD: 'CHANGE PASSWORD',
    DELETE_ACCOUNT: 'Delete user account',
    Old_password: 'Old password',
    New_password: 'New password',
    Repeat_new_password: 'Repeat new password',
    CANCEL: 'CANCEL',
    Fill_this_field: 'Fill this field',
    Old_password_is_incorrect: 'Old password is incorrect',
    Password_must_be_same: 'Password must be same',
    Change_user_password: 'Change user password',
    Password_must_be_at_least: 'Password must be at least',
    characters: 'characters',
    destroy_your_account: 'This will destroy your user account record',
    type_delete_to_confirm: 'Type DELETE if you are sure',
    delete_me: 'DELETE ME',
  },
  time: {
    M: 'M',
    S: 'S',
    d: 'd',
    w: 'w',
    y: 'y',
    H: 'H',
  },
  button: {
    Yes: 'Yes',
  },
  recording: {
    Record_your_screen: 'Record your screen',
    Record_Microphone: 'Record Microphone',
    Record_Webcam: 'Record Webcam',
    cant_start_rec: "Can't start  screen recording, did you select screen? Error",
    Cant_start_camera: "Can't start camera recording, did you allow permissions? Error",
    Webcamera_preview: 'Webcamera preview',
    Start_recording: 'Start recording',
    recording_screen_now: 'You are recording your screen now',
    Stop_recording: 'Stop recording',
  },
  loader: {
    Loading: 'Loading',
  },
  rule: {
    When: 'When',
    Else: 'Else',
    Action: 'Action',
    Condition: 'Condition',
  },
  trackTimeBar: {
    Unassign: 'Unassign',
  },
  downloadMobile: {
    Get_Tracklify_mobile: 'Get Tracklify mobile app',
    Browse: 'Browse',
    discuss_your_tasks: 'discuss your tasks, manage team on mobile or',
    quickly_creates_tasks: 'quickly creates tasks from screenshots shares',
    You_have_Tracklify: 'You already have Tracklify app on your smartphone',
    Reports: 'Reports',
  },
  title: {
    select_text_and: 'select text and ctrl + l',
  },
  trackingNotice: {
    __tracking_going: 'Tracklify is going to make a screenshots to prove your time spent on work',
    __please_share: 'Please share your Entire screen so we can capture it',
    __choose_entire_screen: 'In the browser window, choose Entire Screen, then click Share',
    __window_or_tab_wont_work: "Sharing a single Window or Chrome Tab won't work",
    __tracking_makes_screenshots:
      'Tracklify makes only one screenshot per 10 minutes with a small random time shifts',
    __screenshots_securely:
      'Screenshots are securely stored in the cloud and could be always reviewed and removed (with time loss)',
    __press_cancel: 'Please press Cancel if you don’t want to proove your time',
    __good_try: 'Good try!',
    __selected_one: 'But you have selected',
    __selected_two: 'instead of Entire screen',
    __canceled_sharing: 'You cancelled screen sharing',
    __unfortunately: 'So you will not be able to confirm your time',
    __you_ws_admin: 'Because you are workspace administrator, you can:',
    __we_will_notify: 'We will notify you when screenshot is made or tracking stops',
    __please_notify: 'please allow notifications',
    __notifications_only:
      'Tracklify uses notifications only to notify you about tracking status updates',
    __we_recommended_notifications:
      'We also recommend to make sure your browser notifications are turned on in OS settings',
    __we_recommended_idle: "We recommed to enable 'Device use' permission",
    __we_will_idle: 'We will check your idle',
    __needs_device_use:
      'Tracklify uses "Your device use" permission to automatically stop tracking when you leave computer for longer then 10 minutes.',
    __provide_better:
      'This setting is used only to provide better experience, no Device usage data shared to server.',
    __well_done: 'Well done',
    __we_recommended_hide_popup: 'We recommend to hide you a Browser noisy popup',
    __just_press: 'Just press Hide:',
    __to_leave: 'To leave your work and stop tracking please just close Browser Tab with Tracklify',
    __sorry_we_cant: 'Sorry we can’t start tracking',
    __we_dont_have_perm: 'We do not have permission to access your activity. Please reset all permissions so browser can ask them again.',
    __try_again_btn: 'Try again',
    __dont_track: "Okay, don't track hours",
    __enable_without: 'Enable time tracking without screenshots for project',
    __dont_show_again: "Don't show again",
    __close: 'Close',
    andReload: 'And reload page',
    __choose_chrome_browser: 'Since Tracklify uses modern IDLE detection API, it works only on Chrome Browser (or other based on Chrome)',
    __otherwise: 'Otherwise you can download our Desktop App here:',
    __download: 'DOWNLOAD',
    __update_tracker: 'Update',
    __installing_update: 'Installing…',
    __update_failed: 'Update failed. Click Update to try again.',
    __you_can_disable_screenshots: 'Since You are project creator, you can disable doing screenshots in the',
    __project_settings: 'project settings',
  },
  addTask: {
    project: 'Project',
    search_projects: 'Search projects...',
    no_projects_found: 'No projects found',
    tags: 'Tags',
    no_tags: 'No tags',
    search_tags: 'Search tags...',
    nothing_found: 'Nothing found',
    create_tag: 'create «{name}»',
    create_tag_hint: 'or press enter',
    no_tags_hint: 'This project has no tags yet.',
    create_task: 'Create task',
    create_subtask_for: 'Create subtask for {task}',
    placeholder: 'Type task text here',
    select_picture: 'Select picture',
    ctrl_v_paste: 'Ctrl+V to paste picture from clipboard',
    tap_to_attach: 'Tap to attach a picture',
    or: 'or',
    select_exactly_image: 'Please select an image file',
  },
  invoiceAutoGen: {
    button: 'Autogenerate',
    save_template_first: 'Save the template first',
    title: 'Autogenerate invoice',
    description: 'Generated on the 1st of every month for the previous month, with current report filters.',
    active: 'Active',
    off: 'Off',
    next_invoice_in: 'Next invoice in 1 day | Next invoice in {count} days',
    not_generated: "Invoices won't be generated",
    turn_off: 'Turn off',
    save_failed: "Couldn't turn on autogeneration: check the addresses",
    invoice_for: '{date} · invoice for {month}',
    sent_to: 'Sent to 1 recipient | Sent to {count} recipients',
    will_be_sent_to: 'Will be sent to 1 recipient | Will be sent to {count} recipients',
    email: 'Email',
    additional_email: 'Additional email',
    // {'@'} is a literal @, a bare one starts a linked message in vue-i18n
    additional_email_placeholder: "e.g. accountant{'@'}company.com",
    initiated_by: 'Initiated by',
  },
  devtools: {
    title: 'AI & Automation',
    subtitle: 'Work with Tracklify from your terminal and from AI coding assistants.',
    copy: 'Copy',
    regenerate: 'Regenerate',
    cli: {
      terminal: 'tracklify — cli',
      title: 'Get Tracklify CLI',
      subtitle: 'Get Tracklify CLI application to automate operations like git.',
      token_hint: 'Your token is personal and secret. Keep it safe.',
      regenerate_title: 'Regenerate CLI token?',
      regenerate_subtitle: 'All logged in clients will need to relogin.',
      regenerated: 'CLI token regenerated',
      regenerate_failed: 'Failed to regenerate CLI token',
      branch_hint: 'Create a new branch for current task',
      branch_output: 'Will create branch like feature/<projectname>/<taskHid>/<taskSlug>',
      commit_hint: 'Add feature to commit',
      commit_output: 'Will create commit like "my text <projectname>/<taskHid>/<taskSlug>"',
    },
    mcp: {
      terminal: 'tracklify — mcp',
      title: 'Get Tracklify MCP',
      subtitle: 'Connect an MCP client to your Tracklify workspace.',
      token_hint: 'Add this header with your personal token. It grants access to Tracklify on your behalf, so keep it secret.',
      regenerate_title: 'Regenerate MCP token?',
      regenerate_subtitle: 'Clients using this token will lose access. Apps connected through OAuth keep working.',
      regenerated: 'MCP token regenerated',
      regenerate_failed: 'Failed to regenerate MCP token',
      claude_code_step1: 'Run in your terminal.',
      claude_code_step2: 'Then run in Claude Code, pick tracklify and choose Authenticate.',
      codex_step: 'Codex opens Tracklify in your browser to sign in; if it does not, run codex mcp login tracklify.',
      antigravity_step: 'Add to ~/.gemini/config/mcp_config.json. Antigravity has no OAuth sign-in for Tracklify, so it uses your personal token.',
      other_step: 'Add this URL to your MCP client. With OAuth sign-in it opens Tracklify in your browser to ask for your approval; otherwise add the header below.',
      key: 'Key',
      value: 'Value',
    },
    connections: {
      title: 'Connected apps',
      empty: 'No apps are connected through OAuth sign-in yet.',
      app: 'App',
      connected: 'Connected',
      last_active: 'Last active',
      disconnect: 'Disconnect',
      disconnect_failed: 'Failed to disconnect the app',
    },
  },
  profitShare: {
    breadcrumb: 'Profit-share project /',
    search_projects: 'Search Profit-share projects',
    author: 'Author',
    no_accessible_projects: 'No accessible projects',
    confidential_badge: 'Confidential · screenshots blurred',
    projects_stack: 'projects',
    members_stack: 'members',
    no_participating_projects: 'No participating projects',
    only_author_access: 'Only the author currently has access.',
    edit_project: 'Edit project',
    create_project: 'Create Profit-share project',
    return_to_admin: 'Return to admin view',
    view_as_non_admin: 'View as non-admin',
    loading_project: 'Loading Profit-share project…',
    sections_aria: 'Profit-share sections',
    tab_overview: 'Overview & revenue',
    tab_rates: 'Member rates',
    tab_audit: 'Audit log',
    choose_title: 'Choose a Profit-share project',
    access_count: 'You have access to {n} project. | You have access to {n} projects.',
    opening_shows: 'Opening one shows confidential salary data.',
    tracklify_projects_count: '{n} Tracklify project | {n} Tracklify projects',
    members_count: '{n} member | {n} members',
    new_project: 'New project',
    landing_kicker: 'Profit-share',
    landing_title: 'Share profit transparently across your projects',
    landing_text: 'A Profit-share project pools revenue and tracked costs from several Tracklify projects, then splits what\'s left between participating members.',
    no_access_yet: 'You do not have access to a Profit-share project yet.',

    all_participating: 'All participating projects',
    overview_reveal_hint: 'Member rates and costs remain confidential until a member-month cell is revealed.',
    export_csv: 'Export CSV without members',
    no_operations: 'No tracked operations yet.',
    rate_missing: 'Rate missing',
    vs_six_months: '{change} vs 6 mo ago',
    carry_over: '({amount} carry over)',
    reveal_rate: 'Reveal rate',
    reveal_rate_aria: 'Reveal {member} rate for {month}',
    rate_line: 'rate {rate}',
    mentor_line: '+ mentor {rate}',
    no_effective_rate: 'No effective rate',
    projects_loaded: '{n} project loaded | {n} projects loaded',
    load_details: 'Project “{name}” loaded in {seconds}s · aggregation query {query}s',
    loading_operations: 'Loading project operations…',
    no_participating_selected: 'No participating projects selected.',
    add_revenue: 'Add revenue',
    revenue: 'Revenue',
    latest: 'Latest',
    no_description: 'No description',
    rate_not_set: 'Rate not set',
    delete_revenue_confirm: 'Delete this revenue?',
    delete_revenue: 'Delete revenue',
    no_revenue: 'No revenue yet',
    no_revenue_hint: 'Profit stays negative until revenue is added.',
    update_revenue: 'Update revenue',
    revenue_invalid: 'Amount and rate must be positive numbers, e.g. 1200.50',
    col_month: 'Month',
    col_total_spend: 'Total spend',
    col_rate_efficiency: 'Rate efficiency',
    col_monthly_profit: 'Monthly profit',
    col_distributable_profit: 'Distributable profit',
    col_accumulated_profit: 'Accumulated profit',

    tracklify_project: 'Tracklify project',
    rate_per_hour: 'Rate ({currency}/h)',
    amount: 'Amount',
    currency: 'Currency',
    date: 'Date',
    sold_hours: 'Sold hours',
    note: 'Note',
    note_placeholder: 'e.g. September invoice',

    member_rates_title: 'Member salary rates',
    rates_hint: 'One update per member and month. A rate applies until a newer update replaces it.',
    rates_reveal_hint: 'Rates remain confidential until a member-month cell is revealed.',
    add_rate_update: 'Add rate update',
    no_rates_warning: 'No rates yet. Spend and profit can\'t be calculated until members who track time have a rate.',
    select_projects_first: 'Select participating projects with approved members before adding rates.',
    no_rate_history: 'No rate history yet.',
    confidential_rate: 'Confidential rate',
    edit_rate: 'Edit rate',
    mentor_rate_line: 'Mentor: {rate}',
    hours_not_estimated: 'Hours Not Estimated',
    add_monthly_rate: 'Add monthly rate update',
    add_rate: 'Add rate',
    rates_invalid: 'Rates must be numbers, e.g. 25.50',
    member: 'Member',
    search_members: 'Search members',
    no_members_found: 'No members found',
    month: 'Month',
    new_rate: 'New rate',
    mentor_rate: 'Mentor rate',
    note_optional: 'Note (optional)',

    new_ps_project: 'New Profit-share project',
    edit_ps_project: 'Edit Profit-share project',
    project_name: 'Project name',
    project_name_placeholder: 'e.g. Agency pool 2026',
    members_access: 'Members with confidential access',
    add_members: 'Add workspace members…',
    members_access_hint: 'They will see salary rates, costs, revenue and profit.',
    access_list_author_only: 'The confidential access list is visible only to the project author.',
    participating_projects: 'Participating Tracklify projects',
    add_projects: 'Add projects…',
    participating_hint: 'Workspace admins control this list. Rates are shared across all selected projects.',
    create_project_btn: 'Create project',
    save_project: 'Save project',

    reveal_title: 'Reveal confidential rate?',
    warning: 'Warning',
    reveal_admin_text: 'You are revealing this rate as an administrator, so this attempt will not be written to the audit log. The same confidentiality obligations still apply.',
    reveal_member_text: 'If you continue, this reveal attempt will be permanently recorded in the audit log under your account. {member} will be able to obtain information about this reveal attempt indefinitely. The journal entry cannot be removed, and this action cannot be undone.',
    confidential_caps: 'CONFIDENTIAL',
    confidential_text: 'Rate information is strictly confidential and may be protected by an agreement with the member. By revealing it, you accept full responsibility for keeping the information secure.',
    revealing: 'Revealing…',
    reveal: 'Reveal',

    confidential: 'Confidential',
    consent_title: 'Sensitive Profit-share information',
    rule_see_title: 'What you’ll see',
    rule_see_text: 'This Profit-share project exposes confidential salary rates, tracked costs, revenue, and profit information.',
    rule_stop_title: 'It stops with you',
    rule_stop_text: 'Every company member has the right to keep their salary rate, its history, and the reasons behind it confidential. Although transparency in the Profit-share model makes disclosure to authorized participants unavoidable, any further disclosure must stop with the person viewing it.',
    rule_share_title: 'Don’t share or record it',
    rule_share_text: 'You must not share or record this information in public sources, screenshots, screen recordings, messages, or any other form. Sharing this information with anyone who is not authorized may result in your removal from Profit-share. Tracklify automatically blurs screenshots captured while Profit-share is open.',
    consent_agree: 'I understand all the rules and agree that I may be removed from Profit-share if I share or capture confidential information in any way.',
    asked_again: 'You\'ll be asked again on a new device or browser.',
    agree_open: 'Agree and open',

    audit_title: 'Audit log',
    audit_hint_full: 'Revenue changes, salary-rate changes, and confidential rate reveals.',
    audit_hint_limited: 'Revenue activity and your own confidential reveal actions.',
    loading_audit: 'Loading audit log…',
    no_audit: 'No audit entries yet.',
    page_info: 'Page {page} of {pages} · {total} entries',
    col_time: 'Time',
    col_user: 'User',
    col_entity: 'Entity',
    col_action: 'Action',
    col_diff: 'Diff',
    filter_all_full: 'All finance activity',
    filter_all_limited: 'Revenue and my actions',
    filter_salary: 'Salary rates',
    filter_reveals: 'Rate reveals',
    filter_my_reveals: 'My rate reveals',
    entity_salary: 'Salary rate',
    entity_reveal: 'Rate reveal',
  },
  invoices: {
    invoice_basis: 'Invoice basis',
    close_invoice_basis: 'Close invoice basis',
    close: 'Close',
    edit_filters: 'Edit filters',
    projects: 'Projects',
    include_tags: 'Include tags',
    exclude_tags: 'Exclude tags',
    executors: 'Executors',
    count_projects: '{n} project | {n} projects',
    count_incl_tags: '{n} incl. tag | {n} incl. tags',
    count_excl_tags: '{n} excl. tag | {n} excl. tags',
    count_executors: '{n} executor | {n} executors',
    block_formatting: 'Block formatting',
    font_size_value: 'Font size: {size}',
    font_size: 'Font size',
    alignment: 'Alignment',
    column_width: 'Column width',
    delete_block: 'Delete block',
    delete_text_cell: 'Delete this text cell',
    add_row_after: 'Add Row After',
    add_row_after_title: 'Add a new row after this one',
    delete_column: 'Delete Column',
    delete_column_title: 'Delete this column from the table',
    confirm_delete: 'Confirm Delete?',
    confirm_deletion: 'Confirm deletion',
    cancel_deletion: 'Cancel deletion',
    yes: 'Yes',
    no: 'No',
    font_large: 'Large Font (16px)',
    font_medium: 'Medium Font (14px)',
    font_small: 'Small Font (12px)',
    font_extra_small: 'Extra Small Font (10px)',
    align_left: 'Align Left',
    align_center: 'Align Center',
    align_right: 'Align Right',
    equal_width_columns: 'Equal Width Columns',
    dynamic_width_columns: 'Dynamic Width Columns',
    invoice_generator: 'Invoice Generator',
    invoice_layout: 'Invoice layout',
    add_section: 'Add section',
    add_text_section: 'Add Text Section',
    add_table_section: 'Add Table Section',
    add_block_right: 'Add block to the right',
    add_column_right: 'Add column to the right',
    empty_block: 'Empty block',
    new_row_col: 'New Row {row}, Col {col}',
    new_column: 'New Column {n}',
    delete_table: 'Delete Table',
    delete_row: 'Delete Row',
    delete_table_title: 'Delete this entire table',
    delete_row_title: 'Delete this row from the table',
    invoice_preview: 'Invoice preview',
    download: 'Download',
    generating_pdf: 'Generating PDF…',
    opening_pdf_preview: 'Opening PDF preview…',
    page_of: 'Page {current} of {total}',
    pdf_generation_failed: 'PDF generation failed',
    pdf_generation_error: 'There was an error generating the PDF preview. Please try again.',
    retry: 'Retry',
    saving: 'Saving…',
    saved: 'Saved',
    choose_template: 'Choose an invoice template',
    choose_template_description: 'Pick a saved template to generate an invoice for the filtered tasks, or start a new one from scratch.',
    your_templates: 'Your templates',
    legacy_badge: 'LEGACY',
    shared_badge: 'SHARED',
    created_date: 'Created {date}',
    created_colon_date: 'Created: {date}',
    last_pdf: 'Last PDF: {date}',
    never_capital: 'Never',
    never: 'never',
    or: 'or',
    create_new_template: 'Create new template',
    template_name: 'Template name',
    save_name: 'Save name',
    cancel_renaming: 'Cancel renaming',
    name_cant_be_empty: 'Name can\'t be empty',
    rename_hint: 'Enter to save · Esc to cancel',
    duplicate_name: 'Duplicate {name}',
    duplicate: 'Duplicate',
    rename_name: 'Rename {name}',
    rename: 'Rename',
    delete_name: 'Delete {name}',
    delete: 'Delete',
    templates: 'Templates',
    find_template_placeholder: 'Find template…',
    find_template: 'Find template',
    no_templates_match: 'No templates match "{query}"',
    new_template: 'New template',
    pinned: 'Pinned',
    pinned_title: 'System pinned variable, always exists',
    auto: 'Auto',
    about_name: 'About {name}',
    edit_name_description: 'Edit {name} description',
    edit_description: 'Edit description',
    unlock_name_value: 'Unlock {name} value',
    lock_name_value: 'Lock {name} value',
    unlock_variable: 'Unlock variable',
    lock_variable: 'Lock variable',
    enter_variable_description: 'Enter variable description',
    available_variables: 'Available variables',
    current_value: 'Current value',
    no_variables_found: 'No variables found similar to "{query}"',
    error_badge: 'ERROR',
    template_and_basis: 'Template and invoice basis',
    reset: 'Reset',
    unshare_template: 'Unshare template with workspace',
    shared_click_to_unshare: 'Shared to workspace. Click to unshare',
    save_and_share_confirm: 'Save and share template with workspace? Workspace members will see your template and variables (read-only).',
    share_confirm: 'Share template with workspace? Workspace members will see your template and variables (read-only).',
    share_template: 'Share template with workspace',
    share: 'Share',
    legacy_template_notice: 'This is a legacy template. It can\'t be edited here, but its HTML can be downloaded.',
    download_legacy_html: 'Download Legacy HTML',
    template_variables: 'Template variables',
    template_owner: 'Template owner',
    unknown_user: 'Unknown User',
    current_marker: '(Current)',
    save_and_generate: 'Save and Generate',
    generate: 'Generate',
    delete_template_confirm: 'Are you sure you want to delete this template?',
    unsaved_leave_message: 'Save the changes in this template before leaving it?',
    keep_editing: 'Keep editing',
    untitled_template: 'Untitled template',
    template_copy_name: '{name} (copy)',
  },
  salary: {
    salary_projects_breadcrumb: 'Salary projects /',
    select_salary_project: 'Select salary project',
    generates_monthly_on_day: 'Generates monthly on day {day}',
    generates_weekly_on_day: 'Generates weekly on day {day}',
    recalculating_results: 'recalculating results..',
    create_salary_project: 'Create salary project',
    edit_salary_project: 'Edit salary project',
    confirm_delete_project: 'Are you sure you want to delete this salary project?',
    delete: 'Delete',
    no_projects_yet: 'No salary projects yet. Create one to start.',
    current_period_not_settled: 'Current · {progress} · not settled',
    day_progress: 'day {day} of {total}',
    members_count: '{n} member | {n} members',
    across_members: 'across {n} member | across {n} members',
    add_member: 'Add member',
    search_members: 'Search members',
    add_member_to_current_period: 'Add member to current period',
    member: 'Member',
    user_vars: 'User Vars',
    calculated: 'Calculated',
    export_column_csv: 'Export this column to CSV',
    confirm_remove_member: 'Remove this member from current period?',
    remove_member: 'Remove member',
    summary: 'Summary',
    columns_count: '{shown} of {total} columns',
    metric_min: 'min',
    metric_avg: 'avg',
    metric_max: 'max',
    metric_median: 'median',
    metric_sum: 'sum',
    show_min: 'Show min',
    show_avg: 'Show avg',
    show_max: 'Show max',
    show_median: 'Show median',
    show_sum: 'Show sum',
    select_project_from_list: 'Select a salary project from the list above.',
    popup_subtitle: 'Salaries are generated automatically on a schedule.',
    project_name: 'Project name',
    project_name_placeholder: 'e.g. Kyiv team',
    frequency: 'Frequency',
    week: 'Week',
    month: 'Month',
    day_of_month: 'Day of month',
    day_of_week: 'Day of week',
    of_max_day: 'of {max}',
    timezone: 'Timezone',
    select_timezone: 'Select timezone',
    recreate_to_change_settings: '(if you need to change the settings above please recreate project)',
    variables: 'Variables',
    add_variable: 'Add variable',
    no_variables_yet: 'No variables yet. Add per-member values like base salary or hourly rate.',
    move_up: 'Move up',
    move_down: 'Move down',
    create_project: 'Create project',
    average_salary: 'Average salary',
    total_hours: 'Total hours',
    predicted_salary: 'Predicted salary',
    actually_earned: 'Actually earned',
    own_hours: 'Own hours',
    end_of_month_forecast: 'end-of-month forecast',
    base_percent_hint: 'base {base} · {percent}% of base',
    incl_base_in_eur: 'incl. base salary · in EUR',
    at_rate_per_hour: 'at {rate}/h',
    not_receiving_salary_yet: 'you are not receiving salary in this project yet',
    var_desc_user_time_spent: 'User time spent (hours) in period; optional 3rd arg = email, 4th arg = project name',
    var_desc_user_prediction_median: 'Median of USER_TIME_SPENT over previous N periods (hours); optional email/project filters',
    var_desc_min: 'Return minimal value of two numeric arguments',
    var_desc_previous_salary_point: 'Previous salary point balance',
    var_desc_user_vars: 'Custom user variable (replace var_name with your key)',
    var_desc_exchange_rate: 'Exchange rate {alias}',
    var_desc_exchange_rate_month_start: 'NBU rate on the 1st day of the period month (USD-UAH, EUR-UAH, PLN-UAH, CAD-UAH)',
    var_desc_previously_defined: 'Previously defined variable',
    csv_copied: 'CSV copied to clipboard',
    csv_copy_failed: 'Failed to copy CSV. Please try again.',
  },
  tags: {
    burned_hours: 'Burned hours',
    planned: 'Planned',
    passed: 'Passed',
    est_h: 'Est. h',
    tracked: 'Tracked',
    burned: 'Burned',
    avg_velocity: 'Avg velocity',
    before_sprint: 'Before Sprint',
    during_sprint: 'During sprint',
    all_projects: 'All projects',
    all_sprint_tasks: 'All sprint tasks',
    non_own_sprint_tasks: 'Non-own sprint tasks',
    non_this_project: 'Non-this project',
    effort_change: 'Effort change',
    native_level: 'Native level',
    altruist: 'Altruist',
    sprint_start: 'Sprint start',
    weekends_per_week: 'Weekends / week',
    days_in_sprint: 'Days in sprint',
    show_velocity_stats: 'Show velocity stats',
    show_main_stats: 'Show Main stats',
    burndown: 'Burndown',
    remaining_vs_ideal_pace: 'Remaining hours vs. ideal pace',
    remaining: 'Remaining',
    ideal: 'Ideal',
    remaining_hours: 'Remaining hours',
    ideal_burndown: 'Ideal burndown',
    tag_focus_hotkey: 'Tag focus (Alt+G)',
    tag_focus: 'Tag Focus',
    unfocus: 'Unfocus',
    filter_tags: 'Filter tags...',
    show_eta: 'Show ETA',
    calculate_eta: 'Calculate ETA',
    export_settings: 'Export settings',
    include_executor: 'Include Executor',
    hours_in_story_point: 'Hours in story point',
    round_up_to: 'Round up to',
    include_doing_hint: 'Whether to add doing column so customer can enable/disable items with checkbox',
    include_doing: 'Include Doing',
    notdoing_tag: 'Notdoing tag',
    select_label: 'Select label',
  },
  pages: {
    access_denied_title: 'We are sorry',
    access_denied_subtitle: 'Something went wrong and you were logged out from your active workspace.',
    access_denied_select_workspace: 'Select a workspace to continue',
    access_denied_no_workspaces: 'You have no available workspaces yet.',
    access_denied_create_new: 'Create a new one',
    access_denied_logged_in_as: 'Logged in as {email}',
    access_denied_login_another: 'Log in to another account',
    ai_automation_other_client: 'Other',
    app_download_not_uploaded: 'Not uploaded',
    mcp_authorize_title: 'Connect {client}?',
    mcp_authorize_acts_on_behalf: '{client} ({host}) asks to act on your behalf in the {workspace} workspace: it will see and change everything you can.',
    mcp_authorize_loopback_warning: 'After you answer, your browser returns to an app running on this computer. Allow only if you have just started connecting {client} yourself.',
    mcp_authorize_redirect_notice: 'After you answer, your browser returns to {host}.',
    mcp_authorize_deny: 'Deny',
    mcp_authorize_allow: 'Allow',
    mcp_authorize_invalid: 'This authorization request is invalid or has expired. Start connecting again from your MCP client.',
    project_no_projects_title: 'You have no projects yet 👀',
    project_no_projects_hint: 'Please {create_project} in top left menu by clicking {no_projects}',
    project_create_project: 'create project',
    project_no_projects: 'No Projects',
    project_settings_loading: 'Loading...',
    integrations_add: 'Add integration',
    integrations_added_by: 'Added by {name} · {date}',
    integrations_unknown_user: 'Unknown',
    integrations_close_config: 'Close config',
    integrations_config: 'Config',
    integrations_delete_confirm: 'Delete this integration?',
    integrations_default_description: '{name} integration',
    downtime_snooze_title: 'Snooze for 10 minutes',
    task_notify_priority_title: '{priority} priority',
    report_export_preparing: 'Preparing…',
  },
  ui: {
    ai_chat_empty: 'Ask me to list your projects or create tasks.',
    ai_chat_error: 'Error: {error}',
    ai_chat_openai_auth_error: 'AI Assistant is unavailable: OpenAI API key is invalid or expired.',
    ai_chat_something_went_wrong: 'Something went wrong',
    checklist_progress_title: 'Checklist progress: {done} done from {total}',
    close_button_title: 'Close [ESC]',
    comment_integration: 'Integration',
    comment_unknown_user: 'Unknown',
    common_header_create_task_title: 'Create task [Alt+N]',
    create_task_error_reading_file: 'Error reading file. Please try again.',
    download_mobile_back: 'Back',
    download_mobile_install_app: 'Install App',
    editor_sign_up_not_confirmed: 'Sign up not confirmed',
    header_hidden_members: 'Project has {count} more members:',
    hidden_screenshot_tooltip_in_project: 'You can\'t view this screenshot since you are not member of project {projectName}',
    hidden_screenshot_tooltip_no_project: 'You can\'t view this screenshot since you are not member of this project',
    hidden_task_tooltip_in_project: 'You can\'t view this task since you are not member of project {projectName}',
    hidden_task_tooltip_no_project: 'You can\'t view this task since you are not member of this project',
    integration_bot_name: 'Name',
    integration_bot_title: 'Bot',
    integration_param_readonly: 'readonly',
    pager_try_again_later: 'Please try again later',
    recording_controls_microphone_level: 'Microphone level',
    recording_controls_pause_title: 'Pause screen recording',
    recording_controls_resume_title: 'Resume screen recording',
    recording_controls_stop_title: 'Stop screen recording',
    searcher_no_tags: 'no tags',
    searcher_with_tag: 'With tag:',
    spinner_loading: 'Loading...',
    stage_enter_new_name: 'Stage name cannot be empty',
    stage_no_name: 'No stage name',
    task_click_to_assign: 'Click to assign',
    task_dialog_comments_only: 'Comments only',
    task_dialog_drop: 'Drop',
    task_dialog_logs_shown: 'Logs shown',
    task_dialog_parent_task: 'Parent task',
    task_dialog_return_to_parent: 'Return to parent task',
    task_dialog_scroll_to_top: 'Scroll to top',
    task_dialog_subtasks: 'Subtasks',
    task_dialog_subtasks_caption: 'SUBTASKS',
    task_dialog_toggle_rightbar: 'Task details',
    task_right_bar_add_subtask_title: 'Add subtask [Alt+Ctrl+N]',
    user_avatar_executor_title: 'User {username} is executor of this task',
  },
};
